/**
 * View component for expiring certificates and content modules
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as courseActions from '../../course/courseActions';
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userModuleActions from '../../userModule/userModuleActions';
import * as userNodeActions from '../../userNode/userNodeActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import module components
import StudyLayout from '../../study/components/StudyLayout.js.jsx';
import ContentModuleCard from '../../contentModule/components/ContentModuleCard.js.jsx';

// import utilities
import certUtils from '../../../global/utils/certUtils';
// not updating links here because this should no longer be used with london handling agenda and certs

class CompletedTraining extends Base {
  constructor(props) {
    super(props);
    this.state = {
      courseIds: []
      , queryText: ''
      , sponsorIds: []
      , studyIds: []
      , cmIds: []
    }
    this._bind(
      '_handleQuery'
    )
  }

  componentDidMount() {
    const { loggedInUser, dispatch, studyStore } = this.props;

    // old page - redirect to london certs view just in case
    window.location.replace(`${window.agendaUrl}/certificates`);
    
    dispatch(studyActions.fetchListIfNeeded('user', loggedInUser._id)).then(studyRes => {
      if(studyRes.success && studyRes.list.length > 0) {
        const sponsorIds = studyRes.list.map(s => s._organization);
        const studyIds = studyRes.list.map(s => s._id);
        this.setState({
          sponsorIds
          , studyIds
        });
        dispatch(sponsorActions.fetchListIfNeeded('user', loggedInUser._id));
      }
    });
    dispatch(courseActions.fetchListIfNeeded('user', loggedInUser._id)).then(courseRes => {
    //   const courseIds = courseRes.list.map(c => c._id);
    //   const cmIds = courseRes.list.map(c => c._contentModules).reduce((a,b) => a.concat(b), []);
    //   const uniqueCMIds = Array.from(new Set(cmIds));
    //   this.setState({
    //     courseIds
    //     , cmIds: uniqueCMIds
    //   });
    //   dispatch(contentModuleActions.fetchListIfNeeded('_id', uniqueCMIds));
    });
    dispatch(contentModuleActions.fetchListIfNeeded('user', loggedInUser._id))


    dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id))
    dispatch(userModuleActions.fetchListIfNeeded('_user', loggedInUser._id))
    dispatch(userNodeActions.fetchListIfNeeded('_user', loggedInUser._id));
  }

  _handleQuery(e) {
    this.setState({
      [e.target.name]: e.target.value.toLowerCase()
    });
  }

  render() {
    const {
      courseStore
      , loggedInUser
      , moduleCertificateStore
      , studyStore
      , contentModuleStore
    } = this.props;

    // const {
    //   cmIds
    // } = this.state;

    const studyList = loggedInUser && studyStore.lists.user ? studyStore.lists.user[loggedInUser._id] : {};
    const studies = loggedInUser ? studyStore.util.getList("user", loggedInUser._id) : null;

    const courseList = courseStore.lists.user ? courseStore.lists.user[loggedInUser._id] : {};
    const courses = courseStore.util.getList('user', loggedInUser._id);

    // const cmList = contentModuleStore.lists._id ? contentModuleStore.lists._id[cmIds] : {};
    // const contentModules = contentModuleStore.util.getList('_id', cmIds);
    const cmList = contentModuleStore.lists.user ? contentModuleStore.lists.user[loggedInUser._id] : {};
    const contentModules = contentModuleStore.util.getList('user', loggedInUser._id);


    const isEmpty = (
      !courses
      || !studies
      || !contentModules
    )

    const isFetching = (
      !courseList
      || courseList.isFetching
      || !studyList
      || studyList.isFetching
      || !cmList
      || cmList.isFetching
    )

    const cmsEmpty = (
      !cmList
      || !cmList.items
      || cmList.items.length === 0
      || cmList.didInvalidate
      || !contentModules
    );
    let incompleteCMs = [];
    let completedCMs = [];
    let expiringCMs = [];
    let expiredCMs = [];
    let excludedCMs = []; // 1.12

    // TODO: need to redo all this logic if/when we rewrite the agenda page
    // TODO: since making this switch to show by statuses, the searching piece is broken

    const certs = moduleCertificateStore.util.getList('_user', loggedInUser._id);
    if(!cmsEmpty) {
      // try to find a valid cert for each content module
      // this is for DISPLAY PURPOSED ONLY - the CM card will determine actual navigation and messaging
      for(let cmId of cmList.items) {
        let sortedCerts = certs && certs.filter(cert => cert._contentModule == cmId); 
        if(sortedCerts && sortedCerts.length > 0) {
          let cert = certUtils.findCompletedCert(sortedCerts);
          if(cert && cert.status === 'excluded') {
            excludedCMs.push(cmId); 
            // 1.12 - these will not be displayed
          } else if(cert) {
            // valid cert.  add cmId to complete list; MIGHT STILL NEED TO REDO TRAINING
            completedCMs.push(cmId);
            if(cert.status === 'expiring-soon') {
              expiringCMs.push(cmId);
            }
          } else {
            // this cert is invalid, add cmId to incomplete list
            incompleteCMs.push(cmId);

            // is it also expired? we should only count these IF they also don't have another "completed" cert
            if(sortedCerts.filter(cert => cert.status == 'expired').length > 0) {
              expiredCMs.push(cmId);
            }
          }
          
        } else {
          // no cert exists.  add this cmId to incomplete list
          incompleteCMs.push(cmId);
        }
      }
    }

    return (
      <StudyLayout>
        <div className="flex">
          <section className="section my-agenda">
            <div className="yt-container">
              <div className="yt-row space-between bottom">
                <h2>Completed Training</h2>
              </div>
              <hr/>
              { isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="u-centerText">
                    <h2>No simulations were found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate to your <Link to="/my-agenda">Programs</Link> to select a specific program!</p>
                  </div>
                )
                : 
                <div>
                  { completedCMs.length > 0 ? 
                  <div style={{ opacity: courseStore.selected.isFetching ? 0.5 : 1 }}>
                    <div className="-training">Completed Training</div>
                    <div className="yt-row">
                      {completedCMs.map(cm =>
                        <ContentModuleCard
                          key={cm}
                          showPath={false}
                          contentModule={contentModuleStore.byId[cm]}
                        />
                      )}
                    </div>
                    <hr/>
                  </div>
                  : 
                  <div className="u-centerText">
                    <h3>You haven't completed any training yet!</h3>
                    <Link to="/my-agenda">Go Back</Link> 
                  </div>
                  }
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


CompletedTraining.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseStore: store.course
    , loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , studyStore: store.study
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CompletedTraining)
);



// WEBPACK FOOTER //
// modules/user/views/CompletedTraining.js.jsx